var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAvatarIcon = function SvgAvatarIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#fff",
    rx: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F6F4FF",
    d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCC8DA",
    d: "M27.642 25.356a5.939 5.939 0 0 0-2.464-1.138l-4.386-.88a.99.99 0 0 1-.792-.98v-1.006c.282-.396.548-.922.826-1.472.216-.426.542-1.068.704-1.234.888-.892 1.746-1.894 2.012-3.186.248-1.212.004-1.848-.282-2.36 0-1.278-.04-2.878-.342-4.042-.036-1.576-.322-2.462-1.042-3.238-.508-.55-1.256-.678-1.858-.78-.236-.04-.562-.096-.682-.16A7.058 7.058 0 0 0 15.958 4c-2.634.108-5.872 1.784-6.956 4.772-.336.91-.302 2.404-.274 3.604l-.026.722c-.258.504-.512 1.144-.262 2.36.264 1.294 1.122 2.298 2.026 3.202.148.152.482.8.702 1.228.282.548.55 1.072.832 1.466v1.006c0 .478-.334.89-.796.98l-4.39.88a5.952 5.952 0 0 0-2.456 1.136 1 1 0 0 0-.118 1.456C7.228 30.108 11.514 32 16 32s8.774-1.89 11.76-5.188a1 1 0 0 0-.118-1.456Z"
  })));
};
export default SvgAvatarIcon;